"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const formik_1 = require("formik");
const AuthContext_1 = require("../Auth/AuthContext");
const InputField_1 = __importDefault(require("./InputField"));
const Button_1 = __importDefault(require("./Button"));
const LoginForm = () => {
    let values = {
        email: '',
        password: '',
        remember: false,
    };
    const { signIn } = (0, AuthContext_1.useAuth)();
    const onSubmit = async (values, { setErrors, setSubmitting }) => {
        try {
            await signIn(values.email, values.password, values.remember);
        }
        catch (error) {
            setErrors(error.response.data.errors);
        }
        setSubmitting(false);
    };
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(formik_1.Formik, { initialValues: values, onSubmit: onSubmit }, ({ isSubmitting }) => (react_1.default.createElement(formik_1.Form, null,
            react_1.default.createElement("div", { className: 'space-y-6' },
                react_1.default.createElement(InputField_1.default, { name: "email", type: "text", label: "E-Mail", placeholder: "E-Mail-Addresse" }),
                react_1.default.createElement(InputField_1.default, { name: "password", type: "password", label: "Passwort", placeholder: "******" }),
                react_1.default.createElement("div", { className: "flex items-center" },
                    react_1.default.createElement(formik_1.Field, { type: "checkbox", name: "remember", id: "remember", className: "checkboxx" }),
                    react_1.default.createElement("label", { htmlFor: "remember", className: "ml-2 block text-sm text-gray-900" }, "Angemeldet bleiben")),
                react_1.default.createElement(Button_1.default, { type: "submit", size: 'md', block: true, disabled: isSubmitting }, "Anmelden")))))));
};
exports.default = LoginForm;
